// $FlowFixMe
/* eslint-disable no-console */

import React from 'react';
import ReactDOM from 'react-dom';

import { Modal } from './components/modal';
import { Form, Header } from './components/login';
import { validateUrlParams } from './utils/validators/url-params-validation';
import './i18n';
import { getUrlParam } from './utils/route';
import { getConfig } from './config/config';

const render = () => {
  const formType = getUrlParam('form_type');
  if (!formType) {
    return;
  }
  const config = getConfig(formType);
  const LoginModal = Modal(Form, Header, config.footer, config);
  const el = document.getElementById('sign-in-root');
  if (el !== null) {
    ReactDOM.render(
      <div>
        <LoginModal />
      </div>,
      el,
    );
  }
};

if (validateUrlParams()) {
  render();
} else {
  console.warn('failed params validation');
}
